import { Inject, Pipe, PipeTransform } from '@angular/core';
import { LOCAL_STORAGE } from '@ng-web-apis/common';
import { AppPathInfos, PageTemplate } from '@icilalune/types';
import { DOCUMENT } from '@angular/common';
import {
  Blog,
  Client,
  News,
  Page,
  Project,
  Solution,
} from '@nx-icilalune/data/icilalune/types';

@Pipe({
  name: 'drupalToAngularRoute',
  standalone: true,
})
export class IcilaLuneDrupalToAngularRoutePipe implements PipeTransform {
  constructor(
    @Inject(LOCAL_STORAGE) private localStorage: Storage,
    @Inject(DOCUMENT) private document: Document
  ) {}

  transform(pathInfos: AppPathInfos): string | undefined {
    const { type, id, language, template, frontPage, meta, path } = pathInfos;
    const appTemplate: PageTemplate | undefined =
      pathInfos.meta?.nodeValue?.appTemplate;
    let angularUrl: string | undefined;
    const renderMode: string = this.localStorage.getItem('renderMode') ?? '2d';
    const rootUrl = `/${renderMode}/${language}`;
    if (frontPage) {
      angularUrl = `${rootUrl}#${id}`;
    } else if (type === News.type) {
      angularUrl = `${rootUrl}/news/${id}`;
    } else if (type === Client.type) {
      angularUrl = `${rootUrl}/clients/client/${id}`;
    } else if (type === Blog.type) {
      angularUrl = `${rootUrl}/blogs/${id}`;
    } else if (type === Project.type) {
      angularUrl = `${rootUrl}/projects/project/${id}`;
    } else if (type === Solution.type) {
      angularUrl = `${rootUrl}/solutions/${id}`;
    } else if (type === Page.type) {
      const isSection = appTemplate === 'elevator:section';
      const isClientList = appTemplate === 'list:clients';
      const isNewsList = appTemplate === 'list:news';
      const isBlogsList = appTemplate === 'list:blog';
      const isAppsList = appTemplate === 'list:apps';
      const isServices = appTemplate === 'services';
      const isMadeInLune = appTemplate === 'madeinlune';
      const isMotionDesignList = appTemplate === 'list:motion-design';
      const isOdyssee = appTemplate === 'detail:odyssee';
      const isSettings = appTemplate === 'detail:settings';
      //template === 'elevator:section' ||
      if (isSection) {
        angularUrl = `${rootUrl}#${id}`;
      } else if (isClientList) {
        angularUrl = `${rootUrl}/clients/${id}`;
      } else if (isNewsList) {
        angularUrl = `${rootUrl}/all-news/${id}`;
      } else if (isBlogsList) {
        angularUrl = `${rootUrl}/all-blogs/${id}`;
      } else if (isAppsList) {
        angularUrl = `${rootUrl}/projects/${id}`;
      } else if (isMotionDesignList) {
        angularUrl = `${rootUrl}/projects/${id}`;
      } else if (isServices) {
        angularUrl = `${rootUrl}/services/${id}`;
      } else if (isMadeInLune) {
        angularUrl = `${rootUrl}/made-in-lune/${id}`;
      } else if (isOdyssee) {
        angularUrl = `${rootUrl}/odyssee/${id}`;
      } else if (isSettings) {
        angularUrl = `${rootUrl}/settings/${id}`;
      }
    }
    return angularUrl;
  }
}
